import React, { useEffect, useState } from "react";
import "./styles.css";
import PropTypes from "prop-types";
import { Modal, ModalBody, ModalContent, ModalHeader, ModalOverlay, Spinner, useDisclosure, } from "@chakra-ui/react";
import { getPingTestStatus } from "../../../APIs";
import { CloseIcon } from "../../../Assets/images/svgs";

const progressStatuses = [
  "Testing in progress",
  "Ensure that you are in a good network area",
  "Ensure that device wires are connected properly",
];

const LoaderModal = ({ show, onModalClose, size, imei, onPingTestResponse, handleLoaderModalClose, handlePingTestErr, relayTestStarted, errMsg = "" }) => {
  const { onClose } = useDisclosure();
  const handleModalClose = () => {
    onClose();
    onModalClose();
  };

  const [progressStatus, setProgressStatus] = useState(progressStatuses[0]);

  useEffect(() => {
    if (show && !relayTestStarted) {
      let i = 0;
      const interval = setInterval(() => {
        i++;
        if (i === progressStatuses.length) {
          i = 0;
        }
        setProgressStatus(progressStatuses[i]);
      }, 1000 * 15);
      return () => clearInterval(interval);
    }
  }, [ show, relayTestStarted ]);

  useEffect(() => {
    if (show && imei && !relayTestStarted) {
      getPingTestStatus(imei, (err, data) => {
        if (err) handlePingTestErr();
        else {
          setTimeout(() => {
            onPingTestResponse(data.success);
          }, 1000)
        }
      });
    }
  }, [ relayTestStarted, show, imei, onPingTestResponse, handlePingTestErr ]);

  return (
    <div className="loader-modal">
      <Modal
        isOpen={show}
        onClose={handleModalClose}
        isCentered
        size={size || "md"}
      >
        <ModalOverlay />
        <ModalContent className="loader-modal-content">
          <ModalBody className="loader-modal-body">
            <div className="widget-loader loader">
              {!errMsg ? <Spinner
                size={"xl"}
                thickness="4px"
                speed="0.65s"
                emptyColor="gray.500"
                color="white.600"
              /> : null}
            </div>
            {!errMsg ? <>
              <p className="loader-progress-status">{progressStatus}</p>
              <p className="loader-progress-msg">
                {relayTestStarted ? "It might take upto 2 mins" : "It might take 2 to 5 mins to complete the test"}
              </p>
            </> : null}
            <p className="loader-error-msg">{errMsg}</p>
          </ModalBody>

          <CloseIcon className="loader-modal-close-btn" onClick={handleLoaderModalClose} />
        </ModalContent>
      </Modal>
    </div>
  );
};

LoaderModal.propTypes = {
  open: PropTypes.bool,
  size: PropTypes.string,
  closeBtn: PropTypes.string,
  confirmBtn: PropTypes.string,
  onConfirm: PropTypes.func,
  onModalClose: PropTypes.func,
  hasError: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

export default LoaderModal;
